export const studyTypeText = (type) => {
    const types = {
      'FT': 'Full time',
      'PT': 'Part time'
    }
    return types[type] || type
  }